import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { ReactiveFormsModule } from '@angular/forms';
import { HttpClientModule } from '@angular/common/http';

// thirdparty modules
import { NgImageSliderModule } from 'ng-image-slider';

// modules
import { SharedModule } from './shared/shared.module';
import { AppRoutingModule } from './app-routing.module';

// components
import { AppComponent } from './app.component';
import { LayoutComponent } from './layout/layout.component';
import { HeaderComponent } from './layout/components/header/header.component';
import { FooterComponent } from './layout/components/footer/footer.component';
import { HomeComponent } from './pages/home/home.component';
import { EventComponent } from './pages/event/event.component';
import { TranscendIndiaComponent } from './pages/transcend-india/transcend-india.component';
import { LatestEventComponent } from './pages/latest-event/latest-event.component';
import { SpeakersComponent } from './pages/speakers/speakers.component';
import { ContactComponent } from './pages/contact/contact.component';
import { GalleryComponent } from './pages/gallery/gallery.component';
import { ThemeService } from './shared/services/theme.service';
import { EvolveIndiaComponent } from './pages/evolve-india/evolve-india.component';

@NgModule({
  declarations: [
    AppComponent,
    LayoutComponent,
    HeaderComponent,
    FooterComponent,
    HomeComponent,
    SpeakersComponent,
    ContactComponent,
    GalleryComponent,
    EventComponent,
    TranscendIndiaComponent,
    LatestEventComponent,
    EvolveIndiaComponent
    
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    ReactiveFormsModule,
    HttpClientModule,
    NgImageSliderModule,
    SharedModule
  ],
  providers: [ThemeService],
  bootstrap: [AppComponent]
})
export class AppModule { }
